import Record from './Record'

export default class Log {
  constructor(isChallenge, challengeId, isOldChallenge){
    this.store = []
    this.currentRecordIndex = 0;
    this.remainingPuzzle = 0;
    this.totalMoves = 0;
    this.isChallenge = isChallenge;
    this.challengeId = challengeId;
    this.isOldChallenge = isOldChallenge
  }

  getCurrentRecord(){
    return this.store[this.currentRecordIndex]
  }

  getCurrentRecordLength(){
    const current_record = this.getCurrentRecord()
    return current_record.solution ? current_record.solution.length : Infinity
  }

  createNewRecord(data){
    var newRecord = new Record(data, this.store.length);
    this.store.push(newRecord);
    this.currentRecordIndex = this.store.length - 1
    this.updateData()
  }

  updateData(){
    if(this.isChallenge){
      var remainingPuzzle = this.store.length,
          totalMoves = 0
      this.store.forEach((record)=> {
        if(record.solution && record.solution.length){
          totalMoves += record.solution.length/2
          remainingPuzzle--
        }
      })
      this.remainingPuzzle = remainingPuzzle
      this.totalMoves = totalMoves
      if(!this.isOldChallenge){
        localStorage.setItem("currentChallenge", JSON.stringify(this));
      }
    }
  }

  modifyRecord(data){
    console.log('modify record', data)
    this.store[this.currentRecordIndex].modifyRecord(data)
    this.updateData()
  }

  selectRecord(index){
    if(index >= 0 && index < this.store.length){
      this.currentRecordIndex = index
    }
  }

  nextRecord(){
    this.currentRecordIndex = ((this.currentRecordIndex-1) + this.store.length) % this.store.length
    console.log('index', this.currentRecordIndex)
    return this.store[this.currentRecordIndex]
  }

  getChallengeSolutions(){
    var newStore = this.store.map(function(record){
      return {
        solution: record.solution,
        goal: record.goal,
        goalColor: record.goalColor
      }
    })
    return {
      remainingPuzzle: this.remainingPuzzle,
      totalMoves: this.totalMoves,
      store: newStore,
      config: this.store[0].boardConfig,
      challengeId: this.challengeId
    }
  }
}


// WEBPACK FOOTER //
// ./game/Log.js